/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : CanvasElement.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import React, { useState } from "react";
import PropTypes from "prop-types";
import { ComponentRegistry } from "./registry";
import { Rnd } from "react-rnd";

export default function CanvasElement({
  element,
  zoom,
  isSelected,
  onSelect,
  onUpdate,
}) {
  const [isEditing, setIsEditing] = useState(false);

  const reg = ComponentRegistry[element.type];
  if (!reg) return null;

  const content = reg.canvas(
    element,
    (updates) => onUpdate(element.id, updates),
    isEditing,
    setIsEditing
  );

  console.log(element, "element.type");

  return (
    <Rnd
      size={{
        width: element.width * zoom,
        height: element.height * zoom,
      }}
      position={{
        x: element.x * zoom,
        y: element.y * zoom,
      }}
      onDragStop={(_, d) =>
        onUpdate(element.id, {
          x: d.x / zoom,
          y: d.y / zoom,
        })
      }
      onResizeStop={(_e, _d, ref, _delta, pos) =>
        onUpdate(element.id, {
          width: Number.parseFloat(ref.style.width) / zoom,
          height: Number.parseFloat(ref.style.height) / zoom,
          x: pos.x / zoom,
          y: pos.y / zoom,
        })
      }
      style={{
        border: isSelected ? "2px solid #2563EB" : "none",
        borderRadius: 4,
        padding: 2,
        background: "#fff",
      }}
      disableDragging={isEditing}
      enableResizing={!isEditing}
      onClick={(e) => {
        e.stopPropagation();
        onSelect();
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        {content}
      </div>
    </Rnd>
  );
}

CanvasElement.propTypes = {
  element: PropTypes.shape({
    id: PropTypes.any,
    type: PropTypes.string,
    x: PropTypes.number,
    y: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  zoom: PropTypes.number,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
  onUpdate: PropTypes.func,
};
